import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  findAllDecisionTypesPageble,
  createDecisionType,
  deleteDecisionType,
  updateDecisionType,
  deleteErrorDecisionType,
  createDecisionTypeWithAttachment,
  updateDecisionTypeWithAttachment,
} from '../../actions/decisionType';
import {
  findDecisionTypeAttachment,
  deleteErrorDecisionTypeAttachment,
  findDecisionTypeAttachmentByDecisionTypeName,
} from '../../actions/decisionTypeAttachment';
import DecisionTypeTable from '../DecisionType/DecisionTypeTable';
import { TablePagination } from '@material-ui/core';
import withTranslations from '../../utils/HighOrderComponent';
import LoadingIndicator from '../Reusable/LoadingIndicator';
import {
  numberOfItemsPerPage,
  rowsPerPageOptions,
} from '../../constants/globals.js';
import { changePaginationTextToSerbian } from '../../utils';

class DecisionTypeList extends Component {
  constructor() {
    super();
    this.state = {
      activePage: 0,
      numberOfItemsPerPage: numberOfItemsPerPage,
      modalIsOpened: false,
    };
  }
  componentDidMount() {
    this.props.findAllDecisionTypesPageble(0, this.state.numberOfItemsPerPage);
  }

  handlePreviewClose = () => {
    this.props.deleteErrorPhysicalEntity();
  };

  isModalOpened = (show) => {
    this.setState({ modalIsOpened: show ? true : false });
  };

  handlePageChange = (event, value) => {
    this.setState({
      activePage: value,
    });
    this.props.findAllDecisionTypesPageble(
      value,
      this.state.numberOfItemsPerPage
    );
  };

  handleChangeRowsPerPage = (event, value) => {
    this.props.findAllDecisionTypesPageble(0, event.target.value);

    this.setState({
      numberOfItemsPerPage: event.target.value,
      activePage: 0,
    });
  };

  render() {
    const { error, decisionTypeList, totalElements } =
      this.props.decisionType || {};

    const {
      isLoadingNeeded,
      decisionTypeAttachment,
      deleteErrorDecisionType,
      deleteDecisionType,
      updateDecisionType,
      createDecisionType,
    } = this.props || {};
    const { decisionAttachment, attachmentContent } =
      decisionTypeAttachment || {};
    const { decisionContent } = attachmentContent || {};
    const format = decisionAttachment?.mimeTypeShort?.substring(1) || {};

    if (isLoadingNeeded) {
      return <LoadingIndicator />;
    }

    return (
      <div className="wrapper-fade-in content-min-height mb-5 mt-2">
        <div className="container">
          <DecisionTypeTable
            decisionTypeList={decisionTypeList}
            deleteDecisionType={deleteDecisionType}
            updateDecisionType={updateDecisionType}
            createDecisionType={createDecisionType}
            deleteError={deleteErrorDecisionType}
            createDecisionTypeWithAttachment={
              this.props.createDecisionTypeWithAttachment
            }
            updateDecisionTypeWithAttachment={
              this.props.updateDecisionTypeWithAttachment
            }
            error={error}
            isModalOpened={this.isModalOpened}
            findDecisionTypeAttachment={this.props.findDecisionTypeAttachment}
            findDecisionTypeAttachmentByDecisionTypeName={
              this.props.findDecisionTypeAttachmentByDecisionTypeName
            }
            decisionContent={decisionContent}
            format={format}
            deleteErrorDecisionTypeAttachment={
              this.props.deleteErrorDecisionTypeAttachment
            }
          />
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <TablePagination
              component="div"
              count={Number(totalElements)}
              page={this.state.activePage}
              onPageChange={this.handlePageChange.bind(this)}
              rowsPerPageOptions={rowsPerPageOptions}
              onRowsPerPageChange={this.handleChangeRowsPerPage.bind(this)}
              rowsPerPage={this.state.numberOfItemsPerPage}
              labelRowsPerPage={this.props.t.rowPerPage}
              labelDisplayedRows={(obj) =>
                changePaginationTextToSerbian(obj, this.props.t.of)
              }
            />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  decisionType: state.decisionType,
  isLoadingNeeded: state.decisionType.loading,
  decisionTypeAttachment: state.decisionTypeAttachment,
});

const mapDispatchToProps = (dispatch) => {
  return {
    findAllDecisionTypesPageble: (pageNumber, pageSize) => {
      dispatch(findAllDecisionTypesPageble(pageNumber, pageSize));
    },
    createDecisionType: (decisionType, callback, messageTitle) => {
      dispatch(createDecisionType(decisionType, callback, messageTitle));
    },
    deleteDecisionType: (id, messageTitle) => {
      dispatch(deleteDecisionType(id, messageTitle));
    },
    updateDecisionType: (decisionType, callback, type, messageTitle) => {
      dispatch(updateDecisionType(decisionType, callback, type, messageTitle));
    },
    deleteErrorDecisionType: () => {
      dispatch(deleteErrorDecisionType());
    },
    createDecisionTypeWithAttachment: (
      formData,
      callback,
      type,
      messageTitle
    ) => {
      dispatch(
        createDecisionTypeWithAttachment(formData, callback, type, messageTitle)
      );
    },
    updateDecisionTypeWithAttachment: (
      formData,
      callback,
      decisionType,
      messageTitle
    ) => {
      dispatch(
        updateDecisionTypeWithAttachment(
          formData,
          callback,
          decisionType,
          messageTitle
        )
      );
    },
    findDecisionTypeAttachment: (decisionTypeId) => {
      dispatch(findDecisionTypeAttachment(decisionTypeId));
    },
    deleteErrorDecisionTypeAttachment: () => {
      dispatch(deleteErrorDecisionTypeAttachment());
    },
    findDecisionTypeAttachmentByDecisionTypeName: (
      decisionTypeName,
      controllerReference
    ) => {
      dispatch(
        findDecisionTypeAttachmentByDecisionTypeName(
          decisionTypeName,
          controllerReference
        )
      );
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslations(DecisionTypeList, 'DecisionTypeList'));
